import en from './en'
import es from './es'
import ca from './ca'

const languages = {
  'en': en,
  'es': es,
  'ca': ca,
}

const getCurrentLanguage = () => {
  const supportedLanguages = ['en', 'es', 'ca']

  // Check for ?lang= URL parameter first
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const langParam = urlParams.get('lang');
    if (langParam && supportedLanguages.includes(langParam)) {
      return langParam;
    }
  } catch (e) {}

  let lang = 'en'
  try {
    lang = navigator.language.includes('-') ? navigator.language.split('-')[0] : navigator.language;
  } catch (e) {
    console.log('Language detection error:', e)
  }

  // Ensure we only return supported languages
  return supportedLanguages.includes(lang) ? lang : 'en'
}

// Helper function to get localized content
const getLocalizedContent = (contentObject, fallbackLang = 'en') => {
  const currentLang = getCurrentLanguage()
  
  if (contentObject && typeof contentObject === 'object') {
    if (contentObject[currentLang]) {
      return contentObject[currentLang]
    } else if (contentObject[fallbackLang]) {
      return contentObject[fallbackLang]
    } else {
      // Return the first available language as last resort
      const firstAvailableLang = Object.keys(contentObject)[0]
      return contentObject[firstAvailableLang] || ''
    }
  }
  
  // If it's not an object, return as is (for backward compatibility)
  return contentObject || ''
}

const Literal = (text) => {
  
  let lang = 'en'
  try {
    lang = navigator.language.includes('-') ? navigator.language.split('-')[0] : navigator.language;
  } catch (e) {
    console.log('E', e)
  }

  try {
    if (typeof languages[lang] !== 'undefined' && typeof languages[lang][text] !== 'undefined') {
      return languages[lang][text]
    } else if (typeof languages['en'] !== 'undefined' && typeof languages['en'][text] !== 'undefined') {
      return languages['en'][text]
    } else {
      return text
    }
  } catch (e) {
    return text
  }
}

export default Literal
export { getCurrentLanguage, getLocalizedContent }
